import { IGetInformacaoFaturamentoByIdUseCase } from "../../../presentation/useCases/read/get_informacao_faturamento_by_id_use_case";
import { InformacaoFaturamentoDetalhes } from "../../models/informacao_faturamento_detalhes";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetInformacaoFaturamentoByIdUseCase
 */

export class GetInformacaoFaturamentoByIdUseCase implements IGetInformacaoFaturamentoByIdUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getInformacaoFaturamentoById(
    idInformacaoFaturamento: number,
  ): Promise<InformacaoFaturamentoDetalhes> {
    const results = await this.repository.getInformacaoFaturamentoById(
      idInformacaoFaturamento,
    );
    if (results === null) throw new Error('Falha ao buscar informação de faturamento!');
    return results;
  }
}
